"use strict";

exports.__esModule = true;
exports.Record = void 0;
var _lodash = require("lodash");
const Record = exports.Record = {
  make: (arg = {}) => ({
    ...arg
  }),
  getValue: (record, fieldKey, path = []) => (0, _lodash.get)(record, [fieldKey, ...path])
};
//# sourceMappingURL=record.js.map